/// <reference path="../typings/index.d.ts" />
/// <reference path="SniperLog.d.ts" />
namespace App {
    export class SniperLog implements ISniperLog {
        private elEspacoLog: JQuery = null;
        private elBtLimparlog: JQuery = null;
        private elBtLoadlog: JQuery = null;

        constructor(elEspacoLog: JQuery, elBtLimparlog: JQuery, elBtLoadlog: JQuery) {
            this.elEspacoLog = elEspacoLog;
            this.elBtLimparlog = elBtLimparlog;
            this.elBtLoadlog = elBtLoadlog;
            this.elBtLimparlog.on('click', () => { this.aoLimparLog(); });
        }

        private aoLimparLog() {
            this.elEspacoLog.html('');
        }

        public exibirLoadLog() {
            if (this.elBtLoadlog) {
                this.elBtLoadlog.show();
            }
        }

        public ocultarLoadLog() {
            if (this.elBtLoadlog) {
                this.elBtLoadlog.hide();
            }
        }

        public exibirLog(titulo: string, descricao: string, tipo: string): void {
            this.elEspacoLog.prepend(`<span class="badge badge-pill text-uppercase badge-${tipo}">${titulo}</span>\n\
            <span class="text-muted pull-right mt-1 font-size-10">${new Date().toLocaleString()}</span>\n\
            <p class="description border-bottom">${descricao}</p>`);
        }
    }
}
